<div class="remark-failed">
  <!-- Date time attribute is used within RecordingPlaybackTabService -->
  <ftr-date
    [date]="remark.startTime"
    [format]="dateFormats.Time"
    [attr.data-datetime]="remark.startTime"
    class="remark-failed__time"
  ></ftr-date>
  <div class="remark-failed__content">
    <span class="remark-failed__content-end-time">
      <span class="remark-failed__content-end-time__hyphen">-</span>
      <ftr-date [date]="remark.endTime" [format]="dateFormats.Time"></ftr-date>
    </span>
    <div class="remark-failed__content-container">
      <span class="remark-failed__content-title">
        <ftr-icon
          class="remark-failed__content-error"
          icon="Error"
          size="Small"
          color="BrandDarker"
          align="TextBottom"
        ></ftr-icon>
        Error getting text
      </span>
      <p class="remark-failed__content-summary">
        Please
        <!--<a href="#">try again</a> or -->contact
        <a href="mailto:support@fortherecord.com">support&#64;fortherecord.com</a>
        for support.
      </p>
    </div>
  </div>
</div>
